import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';

export default function GlobalMegaMenu() {
  const [groups, setGroups] = useState({});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    api('/api/navigation/menu')
      .then((data) => mounted && setGroups(data.groups || {}))
      .catch(() => mounted && setGroups({
        Admissions: [
          { title: 'Admissions', url: '/admissions', description: 'Application and admission information' },
          { title: 'Departments', url: '/departments', description: 'Explore academic departments' },
        ],
        Campus: [
          { title: 'Notice Board', url: '/notice-board', description: 'Official notices and announcements' },
          { title: 'Downloads', url: '/downloads', description: 'Forms, calendars and documents' },
          { title: 'Campus Map', url: '/campus-map', description: 'Find offices, schools and units' },
        ],
        Research: [
          { title: 'Research Portal', url: '/research', description: 'Journals and publications' },
          { title: 'Projects', url: '/projects', description: 'Institutional project tracker' },
        ],
      }));
    return () => { mounted = false; };
  }, []);

  const groupEntries = Object.entries(groups).filter(([, items]) => Array.isArray(items) && items.length);
  if (!groupEntries.length) return null;

  return (
    <nav className="relative z-30 border-b border-emerald-900/10 bg-emerald-950 text-white" aria-label="Global mega menu">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3">
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          className="rounded-xl bg-white/10 px-4 py-2 text-sm font-black uppercase tracking-[0.2em] text-white hover:bg-white/20"
          aria-expanded={open}
        >
          Explore FPB
        </button>
        <Link to="/search" className="rounded-xl border border-white/20 px-4 py-2 text-sm font-bold hover:bg-white/10">
          Advanced Search
        </Link>
      </div>

      {open && (
        <div className="absolute left-0 right-0 top-full border-b border-emerald-900/10 bg-white text-slate-900 shadow-2xl">
          <div className="mx-auto grid max-w-7xl gap-6 px-4 py-8 md:grid-cols-2 lg:grid-cols-4">
            {groupEntries.map(([group, items]) => (
              <section key={group}>
                <h3 className="text-sm font-black uppercase tracking-[0.2em] text-emerald-700">{group}</h3>
                <div className="mt-4 space-y-3">
                  {items.map((item) => {
                    const external = item.open_in_new_tab || /^https?:\/\//.test(item.url || '');
                    const content = (
                      <>
                        <span className="block font-black text-slate-950">{item.icon ? `${item.icon} ` : ''}{item.title}</span>
                        {item.description ? <span className="mt-1 block text-xs leading-5 text-slate-600">{item.description}</span> : null}
                      </>
                    );
                    return external ? (
                      <a key={item.id || `${group}-${item.title}`} href={item.url} target="_blank" rel="noopener noreferrer" className="block rounded-2xl border border-slate-100 p-4 hover:border-emerald-200 hover:bg-emerald-50">
                        {content}
                      </a>
                    ) : (
                      <Link key={item.id || `${group}-${item.title}`} to={item.url || '/'} onClick={() => setOpen(false)} className="block rounded-2xl border border-slate-100 p-4 hover:border-emerald-200 hover:bg-emerald-50">
                        {content}
                      </Link>
                    );
                  })}
                </div>
              </section>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
